export default __webpack_public_path__ + "static/media/copy.2ad163b6.svg";